<script setup>
import { ref } from 'vue';

/**
 * @typedef {object} CsFileDialogProps
 * @property {boolean} [autoReset=true] - Whether to reset the file input when a file is added
 * @property {string} [accept] - The file types to accept
 */

/**
 * @type {CsFileDialogProps}
 */
const props = defineProps({
  autoReset: {
    type: Boolean,
    default: true,
  },
  accept: {
    type: String,
    default: '*',
  },
});

const emit = defineEmits(['change', 'add-file']);

const input = ref(null);

function onAddFile(event) {
  emit('change', event);
  emit('add-file', event.target.files);

  // Clear the file input
  if (props.autoReset) reset();
}

function reset() {
  input.value.value = '';
}

function open() {
  input.value?.click();
}

defineExpose({
  open,
  reset,
});
</script>

<template>
  <div data-component="CsFileDialog">
    <input
      ref="input"
      type="file"
      class="hidden"
      multiple
      :accept="accept"
      @change="onAddFile"
    />

    <slot :open="open" />
  </div>
</template>
